import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'ps-aida-quota-performance-tile',
  templateUrl: './aida-quota-performance-tile.component.html',
  styleUrls: ['./aida-quota-performance-tile.component.css'],
})
export class AidaQuotaPerformanceTileComponent implements OnChanges {
  @Input() aidaEnabled: boolean = false;
  @Input() status?: string = 'GREEN';
  public tileDetails: TileDetails = {} as TileDetails;

  ngOnChanges(): void {
    this.tileDetails = this._setTileDetails();
  }

  private _setTileDetails(): TileDetails {
    switch (this.status) {
      case 'RED':
        return this._redTileDetails();
      case 'YELLOW':
        return this._yellowTileDetails();
      default:
        return this._greenTileDetails();
    }
  }

  private _redTileDetails(): TileDetails {
    return {
      class: 'red',
      bodyText:
        'Some quotas are behind Pace and AIDA™ has been unable to make updates to improve performance for the last four hours.',
      subText:
        'Suggested Actions: Increase your Field Time and/or CPI to increase delivery.',
    };
  }

  private _yellowTileDetails(): TileDetails {
    return {
      class: 'yellow',
      bodyText:
        'Some quotas are behind Pace and AIDA™ is unable to make updates to improve performance.',
      subText:
        'Suggested Actions: Keep an eye on the quotas flagged below and consider updating Current Target, Quota Price, or adding more Field Time.',
    };
  }

  private _greenTileDetails(): TileDetails {
    return {
      class: 'green',
      bodyText:
        'Project is currently fielding as expected. No user actions required.',
      subText: '',
    };
  }
}

export interface TileDetails {
  class: string;
  bodyText: string;
  subText: string;
}
